"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = exports.Menu = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _color = require("../../helpers/color");

var _BorderBox = require("../BorderBox");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Separator = require("../Separator");

var _Spacer = require("../Spacer");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Menu */
var Menu = function Menu(_ref) {
  var title = _ref.title,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["title", "children"]);

  return _react.default.createElement(MenuContainer, _extends({
    width: 230,
    m: "2px"
  }, props), _react.default.createElement(_BorderBox.BorderBox, {
    p: 0,
    pb: 1
  }, _react.default.createElement(_Flex.Flex, {
    flexDirection: "column",
    width: "100%"
  }, title && _react.default.createElement(_Box.Box, {
    px: 2,
    pt: 2,
    pb: 1
  }, _react.default.createElement(_Typography.Sans, {
    size: "3",
    weight: "medium"
  }, title), _react.default.createElement(_Spacer.Spacer, {
    py: 0.5
  }), _react.default.createElement(_Separator.Separator, null)), _react.default.createElement(_Box.Box, {
    pt: title ? 0 : 1
  }, children))));
};

exports.Menu = Menu;
Menu.displayName = "Menu";
var MenuContainer = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Menu__MenuContainer",
  componentId: "gpry8h-0"
})(["background-color:white;box-shadow:2px 2px 4px 2px ", ";"], (0, _color.color)("black5")); // Menu Item

/** MenuItem */
var MenuItem = function MenuItem(_ref2) {
  var children = _ref2.children,
      href = _ref2.href,
      props = _objectWithoutProperties(_ref2, ["children", "href"]);

  return _react.default.createElement(MenuLink, _extends({
    href: href
  }, props), _react.default.createElement(_Box.Box, {
    px: 2,
    py: 1
  }, _react.default.createElement(_Typography.Sans, {
    size: "2",
    weight: "medium"
  }, children)));
};

exports.MenuItem = MenuItem;
MenuItem.displayName = "MenuItem";

var MenuLink = _styledComponents.default.a.withConfig({
  displayName: "Menu__MenuLink",
  componentId: "gpry8h-1"
})(["cursor:pointer;display:flex;text-decoration:none;display:flex;align-items:center;text-decoration:none;", ";&:hover{background-color:", ";}", "{display:flex;align-items:center;}"], _styledSystem.display, (0, _color.color)("black5"), _Typography.Sans);
//# sourceMappingURL=Menu.js.map